import React from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// S3 bucket base URL from environment variables
const S3_BUCKET_URL = process.env.REACT_APP_S3_BUCKET_URL || 'https://myeventshop-images.s3.amazonaws.com';

const CreateEventCTA: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    // S3 image paths based on screen size
    const imageSrc = isMobile 
        ? `${S3_BUCKET_URL}/assets/createEventsCTA-mobile.jpg`
        : `${S3_BUCKET_URL}/assets/createEventsCTA-desktop.jpg`;

    return (
        <Container 
            maxWidth='lg' 
            sx={{ 
                mt: theme.spacing(6), 
                mb: theme.spacing(6),
                px: 0, // Remove left and right padding
                mx: 0, // Remove left and right margin
            }}
            disableGutters // This also removes the default padding
        >
            {/* Main CTA Section - Entire section is clickable */}
            <Box
                onClick={() => navigate('/create-event')}
                sx={{
                    width: { xs: '100vw', sm: '100vw', md: '100vw' },
                    height: { xs: '100vw', sm: '35vw', md: '35vw' },
                    position: 'relative',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    boxShadow: theme.shadows[4],
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    backgroundColor: '#B458C7', // Fallback color matching the image
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    '&:hover': {
                        transform: 'scale(1.01)',
                        boxShadow: theme.shadows[8],
                    },
                    // Add subtle overlay on hover for better UX
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                        zIndex: 1,
                    },
                    '&:hover::after': {
                        opacity: 1,
                    },
                }}
                role="button"
                aria-label="Create Event"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        navigate('/create-event');
                    }
                }}
            >
                {/* Image as a child element instead of background */}
                <Box
                    component="img"
                    src={imageSrc}
                    alt="Create Events & Host In Our Platform"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'fill', // Use 'fill' instead of 'cover' to stretch
                        display: 'block',
                    }}
                />
            </Box>
        </Container>
    );
};

export default CreateEventCTA;
